export default "__VITE_ASSET__1kGa4F6g__"